import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import './IntroText.module.scss'

const IntroText = ({ text }) => (
  <Fragment>
    {text && <div styleName='text' dangerouslySetInnerHTML={{ __html: text }} />}
  </Fragment>
)

IntroText.propTypes = {
  text: PropTypes.string.isRequired
}

export default IntroText



// WEBPACK FOOTER //
// ./src/components/IntroText/IntroText.js